<template>
  <div>
    <contract-form-sidebar
      ref="data"
      :is-sidebar-active.sync="isSidebarActive"
      :data="data"
    />
    <b-button
      v-b-tooltip.hover.v-dark
      v-b-modal.modal-checkout
      variant="gradient-primary"
      class="btn-icon"
      title="Generar Pago"
    >
      <feather-icon icon="FileTextIcon" />
    </b-button>
    <b-button
      v-b-tooltip.hover.v-dark
      v-b-modal.modal-contract-account
      variant="gradient-info"
      class="btn-icon"
      title="Estado de Cuenta"
    >
      <feather-icon icon="CreditCardIcon" />
    </b-button>
    <b-button
      v-b-tooltip.hover.v-dark
      variant="gradient-success"
      class="btn-icon"
      title="Orden Trabajo"
      @click="ot()"
    >
      <feather-icon icon="ToolIcon" />
    </b-button>
    <b-button
      v-b-tooltip.hover.v-dark
      variant="gradient-warning"
      class="btn-icon"
      title="Editar"
      @click="
        isSidebarActive = true;
        handleClick(data, data.idcontrato);
      "
    >
      <feather-icon icon="EditIcon" />
    </b-button>

    <b-modal
      id="modal-checkout"
      ref="modal-checkout"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="lg"
      :title="`Ingresar Pago ${data.codigo} - ${data.apenom}`"
    >
      <checkout
        :contract="data"
        :idcontrato="data.idcontrato"
      />
    </b-modal>

    <b-modal
      id="modal-contract-account"
      ref="modal-contract-account"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      size="xl"
      ignore-enforce-focus-selector=".swal2-container, .swal2-center"
      :title="`Estado Cuenta ${data.codigo} - ${data.apenom}`"
    >
      <contract-account-status :data="data" />
    </b-modal>
  </div>
</template>

<script>
import { BButton, VBTooltip, BForm, BFormGroup } from "bootstrap-vue"
import Checkout from "@/views/home/Checkout.vue"
import { ref } from "@vue/composition-api"
import ContractFormSidebar from "./ContractFormSidebar.vue"
import ContractAccountStatus from "./ContractAccountStatus.vue"
import ModalOt from "./modal/ModalOt.vue"

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    ContractFormSidebar,
    ContractAccountStatus,
    ModalOt,
    Checkout,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const isSidebarActive = ref(false)
    
    return {
      isSidebarActive,
    }
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      show: true,
      dataContrato: [],
    }
  },
  created() {},
  methods: {
    ot() {
      this.$root.$emit("bv::show::modal", "modal-ot")
    },
    handleClick(item, index) {
      this.$refs.data.parametros(item, item.idcontrato)
    },
    reload() {
      this.$root.$emit("bv::hide::modal", "modal-discount")
      this.$emit("reload")
    },
  },
}
</script>

<style></style>
